import {ApiBase, ListOptions} from '@/api/common';
import ApiList from '@/api/list';
import config from '@/config';
import store from '@/store';
import {Mutation} from '@/store';
import {bus} from '@/bus';
import {BusEvent} from '@/models/bus';

export default class School extends ApiBase<School> {
    public static readonly SLUG = 'school';
    private static readonly URL_BASE: string = config.API_ROOT + '/school/';
    
    public name?: string = undefined;
    
    public constructor() {
        super({urlBase: School.URL_BASE});
    }
    
    public assign(response: any): School {
        super.assign(response);
    
        return this;
    }
    
    public static async get(id: number): Promise<School> {
        return this.doGet({
            urlBase: School.URL_BASE,
            id,
            create: (response) => new School().assign(response),
        });
    }
    
    public static async list(): Promise<ApiList<School>> {
        const options: ListOptions<School> = {
            urlBase: School.URL_BASE,
            create: (response) => new School().assign(response),
        };
        return this.doList(options);
    }
    
    public static async listAll(): Promise<ApiList<School>> {
        return this.doList({
            urlBase: School.URL_BASE,
            create: (response) => new School().assign(response),
            all: true,
            readFromCache: () => store.state.schoolList,
            writeToCache: async (list: ApiList<School>) => await store.commit(Mutation.CACHE_SCHOOL_LIST, list),
        });
    }
    
    public async delete(): Promise<void> {
        const id = this.id;
        await super.delete();
        
        // In case the entity is cached
        await store.commit(Mutation.DELETE_FROM_SCHOOL_LIST, id);
        bus.$emit(BusEvent.CACHE_CHANGED);
    }
    
    public async save(): Promise<number> {
        const isNew = !this.id;
        const id = await super.save();
        
        if (isNew) {
            await store.commit(Mutation.ADD_TO_SCHOOL_LIST, this);
        } else {
            await store.commit(Mutation.SCHOOL_UPDATED, this);
        }
        
        bus.$emit(BusEvent.CACHE_CHANGED);
        
        return id;
    }
    
    public getName(): string {
        if (this.name) {
            return this.name;
        }
        return '';
    }
}
